import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.tsx'
import { PrivyProvider } from '@/providers/PrivyProvider'
import { QueryProvider } from '@/providers/QueryProvider'
import { AuthGuard } from '@/features/auth/components/AuthGuard'
import { ErrorBoundary } from '@/components/common/ErrorBoundary'
import { TooltipProvider } from '@/components/ui/tooltip'
import { initSentry } from '@/lib/sentry'
import { initializeThemes } from '@/lib/theme-init'

// Initialize error tracking
initSentry()

// Initialize themes (dark/light mode and color theme) before React renders to prevent flash
initializeThemes()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <HelmetProvider>
          <PrivyProvider>
            <QueryProvider>
              <TooltipProvider>
                <AuthGuard>
                  <App />
                </AuthGuard>
              </TooltipProvider>
            </QueryProvider>
          </PrivyProvider>
        </HelmetProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
)
